import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table, TableBody, TableCell, TableHead, TableRow,
  Paper, Button, TextField, IconButton, Box
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { getAllMissions, createMission } from "../../services/missionService";
import { CircularProgress, Typography } from "@mui/material";

export default function MissionList() {
  const navigate = useNavigate();
  const [missions, setMissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);

  const [newMission, setNewMission] = useState({
    type: "",
    name: "",
    description: "",
    startDate: "",
    targetDate: "",
    startWeight: null,
    targetWeight: null
  });

  useEffect(() => {
    async function load() {
      try {
        const data = await getAllMissions();
        setMissions(data);
      } catch (err) {
        console.error("Kon missies niet laden:", err);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  async function handleCreate() {
    try {
      const created = await createMission(newMission);
      setMissions([...missions, created]);
      setAdding(false);
      setNewMission({
        type: "",
        name: "",
        description: "",
        startDate: "",
        targetDate: "",
        startWeight: null,
        targetWeight: null
      });
    } catch (err) {
      console.error("Kon missie niet aanmaken:", err);
    }
    }
    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px', flexDirection: 'column', gap: 2 }}>
                <CircularProgress />
                <Typography>Missies laden...</Typography>
            </Box>
        );
    }

  return (
    <Paper sx={{ p: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Naam</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Startdatum</TableCell>
            <TableCell>Doeldatum</TableCell>
            <TableCell>Startgewicht</TableCell>
            <TableCell>Doelgewicht</TableCell>
            <TableCell>Acties</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {missions.map(m => (
            <TableRow
              key={m.id}
              onClick={() => navigate(`/missions/${m.id}`)}
              sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
            >
              <TableCell>{m.name}</TableCell>
              <TableCell>{m.type}</TableCell>
              <TableCell>{m.startDate}</TableCell>
              <TableCell>{m.targetDate}</TableCell>
              <TableCell>{m.startWeight ?? "-"}</TableCell>
              <TableCell>{m.targetWeight ?? "-"}</TableCell>
              <TableCell>
                <IconButton color="primary" onClick={() => console.log("Edit", m.id)}>
                  <EditIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {!adding && (
        <Box sx={{ mt: 2 }}>
          <Button variant="contained" onClick={() => setAdding(true)}>
            Nieuwe missie
          </Button>
        </Box>
      )}

      {adding && (
        <Box sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Naam"
            value={newMission.name}
            onChange={e => setNewMission({ ...newMission, name: e.target.value })}
          />
          <TextField
            label="Type"
            value={newMission.type}
            onChange={e => setNewMission({ ...newMission, type: e.target.value })}
          />
          <TextField
            label="Beschrijving"
            value={newMission.description}
            onChange={e => setNewMission({ ...newMission, description: e.target.value })}
          />
          <TextField
            label="Startdatum (dd/mm/yyyy)"
            value={newMission.startDate}
            onChange={e => setNewMission({ ...newMission, startDate: e.target.value })}
          />
          <TextField
            label="Doeldatum (dd/mm/yyyy)"
            value={newMission.targetDate}
            onChange={e => setNewMission({ ...newMission, targetDate: e.target.value })}
          />

          <TextField
            label="Startgewicht (optioneel)"
            value={newMission.startWeight ?? ""}
            onChange={e => setNewMission({ ...newMission, startWeight: e.target.value })}
          />
          <TextField
            label="Doelgewicht (optioneel)"
            value={newMission.targetWeight ?? ""}
            onChange={e => setNewMission({ ...newMission, targetWeight: e.target.value })}
          />

          <Box sx={{ display: "flex", gap: 2 }}>
            <Button variant="contained" onClick={handleCreate}>
              Opslaan
            </Button>
            <Button variant="outlined" color="error" onClick={() => setAdding(false)}>
              Annuleren
            </Button>
          </Box>
        </Box>
      )}
    </Paper>
  );
}